import React from 'react';
import { Icon } from '@hz-design-system/web-ui';

import { TScoreEntry } from 'types/UserReviews';

import Classes from './UserReviewsRatingBreakdown.scss';

type TUserReviewsRatingBreakdownProps = {
  ratings: TScoreEntry[];
  className?: string;
};

const UserReviewsRatingBreakdown = ({ ratings, className }: TUserReviewsRatingBreakdownProps) => {
  const rootClass = className ? `${Classes.root} ${className}` : Classes.root;

  return (
    <ul className={rootClass}>
      {ratings.map(({ key, percent, count }) => (
        <li key={key} className={Classes.progressBar}>
          <div className={Classes.ratingKey}>
            {key}
            <Icon name="saved" color="text-brand-primary" />
          </div>

          <div className={Classes.progress}>
            <div className={Classes.bar} style={{ width: `${percent}%` }} />
          </div>
          <div className={Classes.count}>{count}</div>
        </li>
      ))}
    </ul>
  );
};

export default UserReviewsRatingBreakdown;
